import React from 'react';
import PageLoader from './PageLoader';

// Backward-compat shim. Existing call sites import LoadingSpinner; this
// keeps them working while routing through the unified PageLoader so the
// whole app has one consistent loading look. New code should import
// PageLoader directly with an explicit variant + label.
//
// Size → variant mapping:
//   sm  → inline   (small dots, no min-height)
//   md  → block    (centered, 280px min-height)
//   lg  → full     (full-viewport overlay with bg)
export default function LoadingSpinner({ size = 'md', className = '' }) {
  const variant = size === 'sm' ? 'inline' : size === 'lg' ? 'full' : 'block';
  return <PageLoader variant={variant} className={className} />;
}
